import React, {useEffect, useState} from 'react';
import Grid                         from '@mui/material/Grid';
import AppBarTitle                  from '../../components/common/typography/AppBarTitle';
import {useTranslation}             from 'react-i18next';
import {connect}                    from 'react-redux';
import {setTicketsFilters}          from '../../store/actions/SupportAction';
import MailBox                      from '../../components/common/support/MailBox';
import SelectRealm                  from '../SelectRealm';

const ClosedBox = ({support, setTicketsFilters, selectedRealm}) => {
	const {t} = useTranslation();
	const [tableDisabled, setTableDisabled] = useState(true);

	useEffect(() => {
		if (!support) return;
		setTicketsFilters({Status: ['closed'], sort: {Last_Update: 'DESC'}});
		setTableDisabled(false);

	}, [support, setTicketsFilters]);

	if (!selectedRealm) return <SelectRealm/>;

	return (
		<Grid container spacing={3}>
			<AppBarTitle title={t('support_closed_title')}/>

			<Grid item xs={12}>
				<MailBox disabled={tableDisabled} box="closed"/>
			</Grid>

		</Grid>
	);
};

const mapStateToProps = (state) => {
	return {
		support: state.support.support,
		selectedRealm: state.realm.selected,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setTicketsFilters: (filters) => dispatch(setTicketsFilters(filters))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ClosedBox);